module.exports = __webpack_public_path__ + "img/step-3.0a66e3bd.png";